module.exports = __webpack_public_path__ + "img/btn.cecc8a97.png";